import {Student} from "@/interfaces/student";
import {Keyable} from "@/types/keyable.type";

export const methodSumup = "sumup"
export const methodBankTransfer = "bank_transfer"
export const methodOptions: string[] = [methodSumup/*, methodBankTransfer*/]

export const typeRegistration = "registration"
export const typeGalaRegistration = "gala_registration"
export const typeOptions: string[] = [typeRegistration]

export const statusPending = 'pending';
export const statusPaid = 'paid';
export const statusRefunded = 'refunded';
export const statusFailed = 'failed';

export const statusOptions: string[] = [statusPending, statusPaid, statusRefunded, statusFailed]

export interface Payment {
  "@id"?: string;
  "id"?: number;
  method?: string;
  status?: string;
  amount?: number;
  type?: string;
  date?: string;
  sumupCheckoutId?: string | null;
  sumupCustomerId?: string | null;
  sumupTransactionId?: string | null;
  sumupTransactionCode?: string | null;
  paymentReceiptFile?: any;
  student?: Student;
  items?: Keyable;
}
